import React from "react";
import styles from "./Home.module.css";
import home from "../assets/photos/home.png";
import { Button } from "../Buttons/Button/Button";
import paw from "../assets/logo/paw.svg";

function Home({ setHidden, setShowGallery }) {
  function onClick() {
    setHidden(true);
    setShowGallery(true);
  }

  return (
    <>
      <div className={styles.text}>
        <h1 className={styles.title}>Bienvenidos a Paw Paw Needle</h1>
        <p className={styles.subtitle}>
          Amigurumis y artículos en crochet para acompañar tus momentos
          especiales
        </p>
        <Button onClick={onClick}>Ver fotos</Button>
      </div>
      <img src={paw} alt="Home" className={styles.paw}></img>
      <img src={paw} alt="Home" className={styles.paw2}></img>
      <img src={home} alt="Home" className={styles.photo}></img>
    </>
  );
}

export { Home };
